import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { adminMe, getAdminToken } from "@/lib/adminApi";

export default function ProtectedAdminRoute({ children }) {
  const [status, setStatus] = useState("checking"); // checking | ok | denied
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!getAdminToken()) {
        if (!cancelled) setStatus("denied");
        return;
      }
      try {
        await adminMe();
        if (!cancelled) setStatus("ok");
      } catch {
        if (!cancelled) setStatus("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return (
      <div
        data-testid="admin-auth-loading"
        className="min-h-screen bg-black text-[#F5F5F0] flex items-center justify-center"
      >
        <div className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3]">Checking session…</div>
      </div>
    );
  }
  if (status === "denied") {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
